<template>
  <div class="error-page error">
    <div class="error-image">
      <img src="@/assets/img/404.jpg" alt="">
    </div>
    <div class="error-content-wrapper">
      <div class="error-content-logo d-flex justify-content-center align-items-start">
        <span class="state-icon">
          <errorIcon/>
        </span>
      </div>
      <div class="error-content">
        <p class="error-title">Pedido falhado</p>
        <router-link to="/" class="generic-btn red error-btn">Voltar á homepage</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import errorIcon from "@/components/svg/error-icon.vue";

export default {
  name: "error",
  components : {
    errorIcon
  },
}
</script>